// Copyright aptihealth, inc. 2021 All Rights Reserved

export const getClientIpAddress = async () => {
  // Removed to address https://aptihealth.atlassian.net/browse/AT1-6695
  // TODO: Remove dead code in https://aptihealth.atlassian.net/browse/AT1-6694
};
